<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
      <questionItems  />
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import questionItems from "./questionItems.vue";
export default {
  data() {
    return {
      navBlock: "相關問題",
      navtitle: "問題列表",
      questionTypeId: '',
      titleList: []
    };
  },
  created() {
    // this.getTitle();
  },

  destroyed() {},
  methods: {
  },
  components: {
    NavBar,
    questionItems
  }
};
</script>

<style lang="less" scoped>
@import "../order/allOrder/el_tabs.less";
.content {
  .paddingContent {
    width: 100%;
    overflow: auto;
  }
}
@media screen and (min-width: 769px) {
  .paddingContent {
    min-width: 1210px;
  }
}
@media screen and (max-width: 769px) {
  .paddingContent {
    min-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/question/questionList.vue